import React from 'react';
import { PropTypes } from 'prop-types';

const Alert = ({ status, msg, ...props }) => (
    <div className={`alert alert-${status}`} role="alert" {...props}>
        {msg}
    </div>
);

Alert.propTypes = {
    status: PropTypes.string,
    msg: PropTypes.string,
};

export default Alert;
